module.exports = __webpack_public_path__ + "static/img/CStu8@2x.41fc139b.png";